import { Injectable } from '@angular/core';
import { appConfig } from '../app.config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  readonly base_address: string = appConfig.apiUrl + 'admin/';
  globaltoken: any;

  constructor(private httpclient: HttpClient, private AuthService: AuthService) {
    this.getToken();
  }


  addNewUser(user, bcid, bcids, roleid, kpis) {

    let data = {
      user: user,
      roleId: parseInt(roleid),
      budgetCenterId: parseInt(bcid),
      budgetCenterIds: bcids,
      kpIsIds: kpis,
      bcKPIsIds: kpis
    }
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'AddNewUser', data, { headers, responseType: 'text' })
  }
  LoadYearsList() {
    return this.httpclient.get(this.base_address + 'GetYearsList');
  }

  SearchUsers(username) {
    return this.httpclient.get(this.base_address + 'SearchUsers?username=' + username);
  }

  GetAllUsers() {
    return this.httpclient.get(this.base_address + 'GetAllUsers');
  }

  GetUsers() {
    return this.httpclient.get(this.base_address + 'GetUsers');
  }

  GetUserBasicInfo(id) {
    return this.httpclient.get(this.base_address + 'GetUserBasicInfo?userId=' + id);
  }

  GetUserFullInfo(id, bcid) {
    return this.httpclient.get(this.base_address + 'GetUserFullInfo?userId=' + id + '&selectedBC=' + bcid);
  }

  GetUserRoleClaims(RoleId, UserId) {
    return this.httpclient.get(this.base_address + 'GetUserRoleClaims?RoleId=' + RoleId + '&UserId=' + UserId);
  }

  GetUserBudgetCenters(roleId){
    return this.httpclient.get(this.base_address + 'GetUserBudgetCenters?RoleId=' + roleId);
  }

  UpdateUser(user, bcid, bcids, roleid, kpis, rolecheck) {

    let data = {
      user: user,
      roleId: parseInt(roleid),
      budgetCenterId: parseInt(bcid),
      budgetCenterIds: bcids,
      kpIsIds: kpis,
      bcKPIsIds: kpis
    }

    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + `UpdateUser?IsNew=${rolecheck}`, data, { headers, responseType: 'text' })
  }

  EnablDisableUsers(id, isActive) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'EnablDisableUsers?Id=' + id + '&IsEnabled=' + isActive, { headers, responseType: 'text' })
  }

  UpdateUserRole(id, isMultiRole){
    const headers = new HttpHeaders()
    .set('Content-Type', 'application/json');
    return this.httpclient.post(this.base_address + 'UpdateUserRole?Id=' + id + '&RoleId=' + isMultiRole, { headers, responseType: 'text' })
  }

  GetAssignedUserRoles(userId){
    return this.httpclient.get(this.base_address + 'GetAssignedUserRoles?userId=' + userId);
  }

  LoadBudgetCentersList() {
    return this.httpclient.get(this.base_address + 'LoadBudgetCentersList');
  }

  LoadKPIsList() {
    return this.httpclient.get(this.base_address + 'LoadKPIsList');
  }
  LoadRegionalKPIsList() {
    return this.httpclient.get(this.base_address + 'LoadRegionalKPIsList');
  }

  LoadBcKPIsList(bcid) {
    return this.httpclient.get(this.base_address + 'LoadBcKPIsList?BcId=' + bcid);
  }

  LoadRoles() {
    return this.httpclient.get(this.base_address + 'LoadRoles');
  }


  getToken() {
    this.AuthService.getIdToken().then((res) => {
      this.globaltoken = res;
    })
  }

  AssignBCKPIsAsync(bcid, kpis) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'AssignBCKPIsAsync?BudgetCenterId=' + bcid, kpis, { headers, responseType: 'text' })

  }

  EnablDisableBcKPIs(bcid, kpid, isActive) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'EnablDisableBcKPIs?BcId=' + bcid + '&KpiId=' + kpid + '&IsEnabled=' + isActive, { headers, responseType: 'text' })
  }

  MarkBcKPIsNotRelevant(bcKpiId) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'MarkBcKPIsNotRelevant?BcKpiId=' + bcKpiId, { headers, responseType: 'text' })
  }

  // Kpis APIs

  getKpisData() {
    return this.httpclient.get(this.base_address + 'GetKPIs')
  }
  getRegionalKpisData() {
    return this.httpclient.get(this.base_address + 'GetRegionalKPIs')
  }

  GetActiveKPIs() {
    return this.httpclient.get(this.base_address + 'GetActiveKPIs')
  }

  GetActiveKPIsList() {
    return this.httpclient.get(this.base_address + 'GetActiveKPIsList')
  }

  getKpisById(Id) {
    return this.httpclient.get(this.base_address + 'GetKPIsById?Id=' + Id)
  }
  getRegionalKpisById(Id) {
    return this.httpclient.get(this.base_address + 'GetRegionalKPIsById?Id=' + Id)
  }


  addNewKPI(kpi) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'CreateKpiAsync', kpi, { headers, responseType: 'text' })
  }

  addNewRegionalKPI(kpi) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'CreateRegionalKpiAsync', kpi, { headers, responseType: 'text' })
  }

  UpdateKPI(kpi) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'UpdateKpiAsync', kpi, { headers, responseType: 'text' })
  }
  UpdateRegionalKPI(kpi) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'UpdateRegionalKpiAsync', kpi, { headers, responseType: 'text' })
  }

  AddNewTarget(target) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'CreateRegionalTarget', target, { headers })
  }

  EnablDisableKPIs(id, isActive) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'EnablDisableKPIs?Id=' + id + '&IsEnabled=' + isActive, { headers, responseType: 'text' })
  }
  EnablDisableRegionalKPIs(id, isActive) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'EnablDisableRegionalKPIs?Id=' + id + '&IsEnabled=' + isActive, { headers, responseType: 'text' })
  }

  // FAQ APIS

  GetFAQS() {
    return this.httpclient.get(this.base_address + 'GetFAQS')
  }

  GetActiveFAQS() {
    return this.httpclient.get(this.base_address + 'GetActiveFAQS')
  }

  GetFAQById(faqID) {
    return this.httpclient.get(this.base_address + 'GetFAQById?id=' + faqID)
  }

  AddNewFAQ(faq) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'CreateFAQ', faq, { headers, responseType: 'text' })
  }

  UpdateFAQ(faq) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'UpdateFAQ', faq, { headers, responseType: 'text' })
  }

  EnableDisableFAQ(id, isActive) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'EnablDisableFAQ?Id=' + id + '&IsEnabled=' + isActive, { headers, responseType: 'text' })
  }

  // Documents API

  GetDocs() {
    return this.httpclient.get(this.base_address + 'GetDOCUMENTS')
  }

  GetDocById(faqID) {

    return this.httpclient.get(this.base_address + 'GetDocById?id=' + faqID)
  }

  AddNewDocs(document) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + `CreateDocument?DocumentName=${document.get('DocumentName')}`, document, { reportProgress: true, responseType: 'text' })
  }

  EnablDisableDocuments(id, isActive) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'EnablDisableDocuments?Id=' + id + '&IsEnabled=' + isActive, { headers, responseType: 'text' })
  }

  DownloadDocument(docId) {

    return this.httpclient.get(this.base_address + 'DownloadDocument?FileId=' + docId)
  }

  DeleteDocument(docId) {
    const headers = new HttpHeaders()
    .set('Content-Type', 'application/json');
    return this.httpclient.post(this.base_address + 'DeleteDocuments?Id=' + docId, { headers, reportProgress: true, responseType: 'text' })
  }


  //Glossary API

  GetGolssary() {
    // const headers = new HttpHeaders()
    // .set('Content-Type', 'application/json');

    return this.httpclient.get(this.base_address + 'GetGlossary')
  }

  GetActiveGLOSSARY() {

    return this.httpclient.get(this.base_address + 'GetActiveGLOSSARY')
  }

  GetContactUsMessages() {

    return this.httpclient.get(this.base_address + 'GetContactUsMessages')
  }

  GetGolssaryById(faqID) {
    // const headers = new HttpHeaders()
    // .set('Content-Type', 'application/json');

    return this.httpclient.get(this.base_address + 'GetGlossaryById?id=' + faqID)
  }

  AddNewGolssary(document) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'CreateGlossary', document, { headers, responseType: 'text' })
  }

  UpdateGlossary(glossary) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'UpdateGlossary', glossary, { headers, responseType: 'text' })
  }

  EnableDisableGlossary(id, isActive) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'EnablDisableGlossary?Id=' + id + '&IsEnabled=' + isActive, { headers, responseType: 'text' })
  }


  // Workflows
  GetAllWorkFlowStatuses() {
    return this.httpclient.get(this.base_address + 'GetAllWorkFlowStatuses')
  }



  // FAQ Types

  GetFAQTypes() {
    return this.httpclient.get(this.base_address + 'GetFAQSTypes')
  }

  GetActiveFAQSTypes() {
    return this.httpclient.get(this.base_address + 'GetActiveFAQSTypes')
  }

  GetFAQTypeById(typeId) {
    return this.httpclient.get(this.base_address + 'GetFAQTypeById?id=' + typeId)
  }

  AddNewFAQType(faqType) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'CreateFAQType', faqType, { headers, responseType: 'text' })
  }

  UpdateFAQType(Type) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'UpdateFAQTypes', Type, { headers, responseType: 'text' })
  }



  // GPW GOALS

  GetGpwGoals() {
    return this.httpclient.get(this.base_address + 'GetGpwGoals')
  }

  GetActiveGpwGoals() {
    return this.httpclient.get(this.base_address + 'GetActiveGpwGoals')
  }

  GetGpwGoalsById(goalId) {
    return this.httpclient.get(this.base_address + 'GetGpwGoalsById?id=' + goalId)
  }

  AddNewGPWGoal(gpwGoal) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'CreateGPWGoal', gpwGoal, { headers, responseType: 'text' })
  }

  UpdateGPWGoal(Goal) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'UpdateGPWGoals', Goal, { headers, responseType: 'text' })
  }


  // GPW Outcomes

  GetGpwOutcomes() {
    return this.httpclient.get(this.base_address + 'GetGpwOutcomes')
  }

  GetActiveGpwOutcomes() {
    return this.httpclient.get(this.base_address + 'GetActiveGpwOutcomes')
  }

  GetGpwOutcomesById(outcomeId) {
    return this.httpclient.get(this.base_address + 'GetGpwOutcomesById?id=' + outcomeId)
  }

  AddNewGPWOutcome(gpwOutcome) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'CreateGPWOutcome', gpwOutcome, { headers, responseType: 'text' })
  }

  UpdateGPWOutcomes(Outcome) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'UpdateGPWOutcomes', Outcome, { headers, responseType: 'text' })
  }


  // GPW Outpus

  GetGpwOutputs() {
    return this.httpclient.get(this.base_address + 'GetGpwOutputs')
  }

  GetActiveGpwOutputs() {
    return this.httpclient.get(this.base_address + 'GetActiveGpwOutputs')
  }

  GetGpwOutputsById(OutputId) {
    return this.httpclient.get(this.base_address + 'GetGpwOutputsById?id=' + OutputId)
  }

  AddNewGPWOutput(gpwOutput) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'CreateGPWOutput', gpwOutput, { headers, responseType: 'text' })
  }

  UpdateGPWOutputs(Output) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'UpdateGPWOutputs', Output, { headers, responseType: 'text' })
  }



  // GPW References

  GetGpwReferences() {
    return this.httpclient.get(this.base_address + 'GetGpwReferences')
  }

  GetActiveGpwReferences() {
    return this.httpclient.get(this.base_address + 'GetActiveGpwReferences')
  }

  GetGpwReferencesById(ReferenceId) {
    return this.httpclient.get(this.base_address + 'GetGpwReferencesById?id=' + ReferenceId)
  }

  AddNewGPWReference(gpwReference) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'CreateGPWReference', gpwReference, { headers, responseType: 'text' })
  }

  UpdateGPWReferences(Reference) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'UpdateGPWReferences', Reference, { headers, responseType: 'text' })
  }



  // KpiDefinationLevels

  GetKpiDefinationLevels() {
    return this.httpclient.get(this.base_address + 'GetKpiDefinitionLevels')
  }

  GetActiveKpiDefinationLevels() {
    return this.httpclient.get(this.base_address + 'GetActiveKpiDefinitionLevels')
  }

  GetKpiDefinationLevelsById(ReferenceId) {
    return this.httpclient.get(this.base_address + 'GetKpiDefinitionLevelsById?id=' + ReferenceId)
  }

  AddNewKPIDefinationLevels(KPIDefinationLevel) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'CreateKPIDefinationLevels', KPIDefinationLevel, { headers, responseType: 'text' })
  }

  UpdateDefinationLevels(Level) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'UpdateDefinationLevels', Level, { headers, responseType: 'text' })
  }


  // KpiThresholdLevels

  GetKpiThreshold() {
    return this.httpclient.get(this.base_address + 'GetKpiThresholdValues')
  }

  GetActiveKpiThreshold() {
    return this.httpclient.get(this.base_address + 'GetActiveKpiThresholdValues')
  }

  GetKpiThresholdById(ReferenceId) {
    return this.httpclient.get(this.base_address + 'GetKpiThresholdValuesById?id=' + ReferenceId)
  }

  AddNewKPIThreshold(KPIDefinationLevel) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'CreateKPIThresholdValues', KPIDefinationLevel, { headers, responseType: 'text' })
  }

  UpdateThresholdValues(Threshold) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'UpdateThresholdValues', Threshold, { headers, responseType: 'text' })
  }



  /* Reporting items to be gone to Wesbite Service */

  GetBudgetCenters() {
    return this.httpclient.get(this.base_address + 'GetBudgetCenters')
  }

  GetMyKpis() {
    return this.httpclient.get(this.base_address + 'GetMyKpis')
  }
  GetMyRegionalKpis() {
    return this.httpclient.get(this.base_address + 'GetMyRegionalKpis')
  }

  GetMyBudgetCenters(){
    return this.httpclient.get(this.base_address + 'GetMyBudgetCenters')
  }

  LoadReportingItem(quarter, year, kpid) {
    return this.httpclient.get(this.base_address + 'LoadReportingItem?Quarter=' + quarter + '&Year=' + year + '&BCKpiId=' + kpid)
  }

  LoadRegionalReportingItem(quarter, year, kpid) {
    return this.httpclient.get(this.base_address + 'LoadRegionalReportingItem?Quarter=' + quarter + '&Year=' + year + '&KpiId=' + kpid)
  }

  GetKpiStatuses() {
    return this.httpclient.get(this.base_address + 'GetKpiStatuses')
  }

  GetActiveKpiStatuses() {
    return this.httpclient.get(this.base_address + 'GetActiveKpiStatuses')
  }

  SaveAsDraft(emptyReporting, ReportingItem, bcid, quarter, year, isdraft) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

      let reportingItemId;
      if(emptyReporting){
        reportingItemId = 0
      }
      else{
        reportingItemId = ReportingItem.id;
      }
    let data = {
      budgetCenterKpiId: parseInt(bcid),
      progress: ReportingItem.progress,
      results: ReportingItem.results,
      risksAndIssues: ReportingItem.risksAndIssues,
      nextSteps: ReportingItem.nextSteps,
      context: ReportingItem.context,
      scoreCardScore: parseInt(ReportingItem.scoreCardScore),
      scoreCardDefinition: ReportingItem.scoreCardDefinition,
      kpiStatusId: parseInt(ReportingItem.kpiStatusId),
      quarter: parseInt(quarter),
      year: parseInt(year),
      id: reportingItemId,
      isDraft : isdraft
    };

    return this.httpclient.post(this.base_address + 'SaveAsDraft', data, { headers, responseType: 'json' })
  }

  SaveRegionalAsDraft(emptyReporting, ReportingItem, bcid, quarter, year, isdraft) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

      let reportingItemId;
      if(emptyReporting){
        reportingItemId = 0
      }
      else{
        reportingItemId = ReportingItem.id;
      }
    let data = {
      regionalKpiId: parseInt(bcid),
      progress: ReportingItem.progress,
      results: ReportingItem.results,
      risksAndIssues: ReportingItem.risksAndIssues,
      nextSteps: ReportingItem.nextSteps,
      context: ReportingItem.context,
      scoreCardScore: parseInt(ReportingItem.scoreCardScore),
      scoreCardDefinition: ReportingItem.scoreCardDefinition,
      kpiStatusId: parseInt(ReportingItem.kpiStatusId),
      quarter: parseInt(quarter),
      year: parseInt(year),
      id: reportingItemId,
      isDraft : isdraft
    };

    return this.httpclient.post(this.base_address + 'SaveRegionalAsDraft', data, { headers, responseType: 'json' })
  }

  sendClearence(kpid) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    let data = kpid;

    return this.httpclient.post(this.base_address + 'SendForClearance', data, { headers, responseType: 'text' })
  }

  sendRegionalForClearence(kpid) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    let data = kpid;

    return this.httpclient.post(this.base_address + 'SendRegionalForClearance', data, { headers, responseType: 'text' })
  }

  SubmitWorkflow(reportingId, comment, accept) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    let data = {
      reportingId: reportingId,
      comment: comment,
      accept: accept
    };

    return this.httpclient.post(this.base_address + 'SubmitWorkflow', data, { headers, responseType: 'text' })
  }

  SubmitRegionalWorkflow(reportingId, comment, accept) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    let data = {
      reportingId: reportingId,
      comment: comment,
      accept: accept
    };

    return this.httpclient.post(this.base_address + 'SubmitRegionalWorkflow', data, { headers, responseType: 'text' })
  }

  PublishWorkflow(kpid) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json');

    let data = kpid;

    return this.httpclient.post(this.base_address + 'PublishWorkflow', data, { headers, responseType: 'text' })
  }

  PublishRegionalWorkflow(kpid) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json');

    let data = kpid;

    return this.httpclient.post(this.base_address + 'PublishRegionalWorkflow', data, { headers, responseType: 'text' })
  }

  UploadEvidences(documents, kpid) {

    return this.httpclient.post(this.base_address + `UploadEvidences?KPIReportingID=${kpid}`, documents, { reportProgress: true, responseType: 'text' })
  }

  UploadRegionalEvidences(documents, kpid) {

    return this.httpclient.post(this.base_address + `UploadRegionalEvidences?KPIReportingID=${kpid}`, documents, { reportProgress: true, responseType: 'text' })
  }

  requestAdvise(kpiReportingId, toEmails, notes) {

    let data = {
      ReportingId: kpiReportingId,
      AdviseFrom: toEmails,
      Notes:notes
    }
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'RequestAdvise', data, { headers, responseType: 'text' })
  }
  requestRegionalAdvise(kpiReportingId, toEmails, notes) {

    let data = {
      ReportingId: kpiReportingId,
      AdviseFrom: toEmails,
      Notes:notes
    }
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'RequestRegionalAdvise', data, { headers, responseType: 'text' })
  }

  deleteUserClaim(claimId, useId, roleId){

    let data = {
      claimId: claimId,
      // userId: useId,
      // roleId: roleId
    }

    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + `RemoveUserClaim?userId=${useId}&roleId=${roleId}`, claimId, { headers, responseType: 'text' })

  }

  DownloadWebReporting(data) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.httpclient.post(this.base_address + 'DownloadWebBcKpiResultsExcel', data, { headers, responseType: 'blob' })
  }

}
